import { observable, configure, action, computed } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';
import { route } from 'preact-router';
import PubSub, { topics } from '../lib/pubsub';

configure({ enforceActions: 'always' });

class FfeStore extends LocalModel {
    constructor() {
        super('product', {
            namePlural: 'products',
            sort: '-date -createdDate',
            limit: 500,
        });

    }

    @observable search = '';

    @observable productTotal = 1000;

    @observable productLimit = 10;

    @observable productOffset = 0;

    @observable productSort = 'maingroupsort,intermediategroupsort,subgroupsort,sort,articleno';

    @observable categorySort = 'sort,groupno';

    @observable brand = 'simms';

    @observable mainCategory = undefined;

    @observable intermediateCategory = undefined;

    @observable subCategory = undefined;

    @observable brands = [];

    @observable categories = [];

    @observable products = [];

    @observable dealers = [];

    @action
    updateKeyValue(key, value) {
        this[key] = value;
    }

    @action
    updateObjectKeyValue(obj, key, value) {
        this[obj][key] = value;
    }

    @observable redirectUrl = null;

    async getBrands() {
        const params = new URLSearchParams();
        params.append('hostname', this.currentHostname);
        const response = await util.fetchApi(`/api/integrations/ffe/brands?${params.toString()}`, {
            method: 'GET',
        }, {});
        switch (response.status) {
            case 200:
                // console.log('ffeStore.getBrands', response);
                this.updateKeyValue('brands', response.data.filter(b => b.brandno));
                return response;
            default:
                console.error('ffeStore.getBrands', response);
                return response;
        }
    }

    async getCategories({ brand }) {
        const params = new URLSearchParams();
        params.append('hostname', this.currentHostname);

        if (brand) params.append('brand', brand);
        if (this.categorySort) params.append('sort', this.categorySort);

        const response = await util.fetchApi(`/api/integrations/ffe/categories?${params.toString()}`, {
            method: 'GET',
        }, {});
        switch (response.status) {
            case 200:
                // console.log('ffeStore.getCategories', response);
                this.updateKeyValue('categories', response.data.filter(c => c.categoryno && c.count > 0));
                return response;
            default:
                console.error('ffeStore.getCategories', response);
                return response;
        }
    }

    async getProducts({ append, mainCat = this.mainCategory, brand = this.brand, search = this.search }) {
        const params = new URLSearchParams();
        params.append('hostname', this.currentHostname);

        if (mainCat) params.append('mainCat', mainCat);
        if (brand) params.append('brand', brand);
        if (search) params.append('search', search);
        params.append('sort', String(this.productSort ?? ''));
        params.append('limit', String(this.productLimit ?? ''));
        params.append('offset', String(this.productOffset ?? ''));
        params.append('groupProducts', '1');

        const url = `/api/integrations/ffe/products?${params.toString()}`;

        const response = await util.fetchApi(url, {
            method: 'GET',
        }, {});
        switch (response.status) {
            case 200:
                // console.log('ffeStore.getProducts', response);
                const allProducts = response.data;
                if (append) {
                    this.updateKeyValue('products', [...this.products, ...allProducts]);
                } else {
                    this.updateKeyValue('products', allProducts);
                }
                return response;
            default:
                console.error('ffeStore.getProducts', response);
                return response;
        }
    }

    async getConsumerProducts({ brand = this.brand, search = this.search }) {
        const params = new URLSearchParams();
        params.append('hostname', this.currentHostname);
        if (brand) params.append('brand', brand);
        if (search) params.append('search', search);
        params.append('sort', String(this.productSort ?? ''));
        params.append('limit', String(this.productLimit ?? ''));
        params.append('offset', String(this.productOffset ?? ''));
        params.append('groupProducts', '1');
        const response = await util.fetchApi(`/api/integrations/ffe/products/consumer?${params.toString()}&limit=100`, {
            method: 'GET',
        }, {});
        switch (response.status) {
            case 200:
                console.log('ffeStore.getConsumerProducts', response);
                const allProducts = response.data;
                this.updateKeyValue('products', allProducts);
                return response;
            default:
                console.error('ffeStore.getConsumerProducts', response);
                return response;
        }
    }

    async getDealers() {
        const params = new URLSearchParams();
        params.append('hostname', this.currentHostname);
        const response = await util.fetchApi(`/api/integrations/ffe/dealers?${params.toString()}`, {
            method: 'GET',
        }, {});
        switch (response.status) {
            case 200:
                // console.log('ffeStore.getDealers', response);
                this.updateKeyValue('dealers', response.data);
                return response;
            default:
                console.error('ffeStore.getDealers', response);
                return response;
        }
    }

}

const store = new FfeStore();
export default store;
